// extracted by mini-css-extract-plugin
export default {"container":"Burger_container__+14kN"};